import { Typography, Box, Paper, Grid, Link } from '@mui/material';
import Phone from '../../assets/images/rectangle-1.png'
import Tablet from '../../assets/images/rectangle-2.png'
import Macbook from '../../assets/images/rectangle-3.png'
import SmartWatch from '../../assets/images/rectangle-4.png'
import PowerBank from '../../assets/images/rectangle-5.png'
import Speaker from '../../assets/images/rectangle-6.png'
import SmartTV from '../../assets/images/rectangle-7.png'


export default function AvailableProductList() 
{
    const products = [
        { id: 1, name: 'Mobile Phone', img: Phone, catId: '65cb5c641e133cb8436e4dd4' },
        { id: 2, name: 'Tablet', img: Tablet, catId: '65cc477482513024d3c7f231' },
        { id: 3, name: 'Macbook', img: Macbook, catId: '65cc477a82513024d3c7f236' },
        { id: 4, name: 'Smart Watch', img: SmartWatch, catId: '683bd6b3179d2502c8ace8b9' },
        // { id: 5, name: 'Power Bank', img: PowerBank, catId: '65cb5c641e133cb8436e4dd4' },
        { id: 6, name: 'Speaker', img: Speaker, catId: '68ad82f4c1c3b40d7c4859ac' },
        { id: 7, name: 'Smart TV', img: SmartTV, catId: '683c0e1d179d2502c8ae68ba' },
    ];

    return (
        <Box sx={{ bgcolor: '#FBF9F9', padding: 6 }}>
          <Typography variant="h5" sx={{ color: '#d32f2f', fontWeight: 'bold', mb: 3, textAlign: 'center' }}>
            Available Products in Our Store
          </Typography>

          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 2, sm: 4, md: 6 }} sx={{ maxWidth: 755, display: 'flex', flexDirection: 'row', alignItems: 'center', justifySelf: 'center' }} >
              {products.map((product) => (
                <Grid item xs={1} key={product.id}>
                    <Link href={`/product-categories?category=${product.catId}`} underline="none" >
                    <Paper
                    elevation={3}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: 0,
                      textAlign: 'center',
                      borderRadius: 2,
                      bgcolor: '#fafafa',
                      aspectRatio: '1 / 1',
                      cursor: 'pointer',
                      '&:hover': {
                        boxShadow: 6,
                        bgcolor: '#eeeeee',
                      },
                    }}
                  >
                    {/* <Typography variant="h1" sx={{ color: '#455a64', mb: 1, fontSize: { xs: '3rem', sm: '4rem' } }}>
                      {product.icon}
                    </Typography> */}
                      <Box
                          component="img"
                          src={product.img} 
                          alt={product.name}
                          sx={{
                              width: '100%',
                              height: 'auto',
                              maxHeight: '60%',
                              objectFit: 'contain',
                              mb: { xs: 0.5, sm: 1 },
                          }}
                      />
      
                      <Typography variant="caption" sx={{ color: '#616161', fontWeight: '500' }}>
                        {product.name}
                      </Typography>
                  </Paper>
                    </Link>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
    );
}